/**
 * Consistent footer for all public-facing pages.
 * RR-19: Brand, Terms, Privacy, support/contact.
 */
import { Link } from 'react-router-dom';
import AppLogo from './AppLogo';
import { SUPPORT_EMAIL, SUPPORT_MAILTO } from '../lib/supportContact';
import { useSmsLive } from '../hooks/useSmsLive';

export default function PublicFooter() {
  // The SMS Terms link returns by itself once texting is live (sms_notifications 'on').
  const smsLive = useSmsLive();
  return (
    <footer className="border-t border-[var(--border-default)]/80 bg-[var(--surface-muted)]/80 mt-auto">
      <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 sm:py-8 lg:px-8">
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between sm:items-center">
          <Link to="/" className="flex items-center gap-2 text-[var(--text-secondary)] hover:text-[var(--text-primary)] transition">
            <AppLogo markSize={22} clickable={false} />
          </Link>
          <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-[var(--text-secondary)]">
            <Link to="/terms" className="hover:text-rose-600 hover:underline font-medium">
              Terms
            </Link>
            <Link to="/privacy" className="hover:text-rose-600 hover:underline font-medium">
              Privacy
            </Link>
            {smsLive && (
              <Link to="/sms-terms" className="hover:text-rose-600 hover:underline font-medium" data-testid="footer-sms-terms">
                SMS Terms
              </Link>
            )}
            <Link to="/support" className="hover:text-rose-600 hover:underline font-medium">
              Support
            </Link>
          </nav>
        </div>
        <p className="mt-4 text-center sm:text-left text-xs text-[var(--text-muted)]" data-testid="public-footer-brand">
          © {new Date().getFullYear()} Arevina
          {' · '}
          <a
            href={SUPPORT_MAILTO}
            className="hover:text-rose-600 hover:underline font-medium text-[var(--text-secondary)]"
          >
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </footer>
  );
}
